import { SearchQuery } from "../../code/search-query/search-query";
import ManagedGridView from "../../controls/ManagedGridView";
import { getCounsellingRequests } from "../../repository/data.repository";
import { createGridRequest } from "../../hooks/useGridRequest";
import {
  counsellingRequestsViewColumns,
  mapCounsellingRequestsViewQuery,
  counsellingRequestsSearchSchema,
} from "./CounsellingRequestsView.default";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";

export interface CounsellingRequestsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function CounsellingRequestsView(props: CounsellingRequestsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={counsellingRequestsViewColumns}
      schema={counsellingRequestsSearchSchema}
      mapQuery={mapCounsellingRequestsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getCounsellingRequests, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "manage",
          label: "Manage",
          disabled: !permissions.can("CounsellingRequests", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("CounsellingRequests", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default CounsellingRequestsView;
